import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';
import {getImageProps} from 'app/utilities/ImageProps';
import MembersItemBlockData from 'app/Models/Content/MembersItemBlockData';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import './MemberItemBlock.scss';
import TagName from 'app/Components/Shared/TagName';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import x from '../../Shared/Popup/images/x.svg';

type MemberItemProps = {
  data: MembersItemBlockData;
  context: IEpiserverContext;
};

const MemberItemBlock = ({data, context}: MemberItemProps) => {
  const [isFlipped, setIsFlipped] = useState<boolean>(false);
  const [showPopUp, setShowPopUp] = useState<boolean>(false);

  const toggleAction = () => {
    !isMobile && setIsFlipped((prevState) => !prevState);
    isMobile && setShowPopUp(true);
  };
  return (
    <>
      <div role='button' tabIndex={0} onClick={() => toggleAction()} className='MemberItemBlock__wrapper'>
        <div className={`MemberItemBlock__wrapper__image-and-description ${isFlipped ? `is-flipped` : ``}`}>
          <div className='MemberItemBlock__wrapper__image-and-description__image-container face-to-flip'>
            <Image className='MemberItemBlock__wrapper__image-and-description__image-container__image'
              {...getImageProps(data.image, context)} />
          </div>

          <div className='MemberItemBlock__wrapper__image-and-description__description face-to-flip'>{data?.text?.value}</div>
        </div>
      </div>

      {/* we use reactstrap modal to handle issues with scrolling */}

      <Modal scrollable className='MemberItemBlock__container-popup' isOpen={showPopUp} toggle={() => setShowPopUp(false)}>
        <ModalHeader onClick={() => setShowPopUp(false)} className='MemberItemBlock__container-popup__close-btn' style={{backgroundImage:x.bg()}}></ModalHeader>
        <ModalBody>
          <Image className='MemberItemBlock__container-popup__popup-image' {...getImageProps(data.image, context)} />
          <div className='MemberItemBlock__container-popup__title-and-subtitle'>
            <TagName
              className='MemberItemBlock__container-popup__title-and-subtitle__title'
              isTitle
              tagName={data?.titleHeadlineTag?.value}>
              {data?.title?.value}
            </TagName>
            <span className='MemberItemBlock__container-popup__title-and-subtitle__subtitle'>{data?.subTitle?.value}</span>
          </div>
          <div className='MemberItemBlock__container-popup__popup-description'>
            <div dangerouslySetInnerHTML={{__html: data?.text?.value}}></div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default MemberItemBlock;
